import { connect } from 'react-redux';

import CategoricalComponent from './Component';

import {
  getSamplesSpecificationsTableData
} from 'store/scenes/randomizationHypothesisTesting/samples/selectors';

import {
  getPrimaryParameterLevel
} from 'store/scenes/randomizationHypothesisTesting/primaryParameterLevel/selectors';
import { getPrimaryParameter } from 'store/scenes/randomizationHypothesisTesting/primaryParameter/selectors';

const mapStateToProps = state => ({
  data: getSamplesSpecificationsTableData(state),
  primaryParameter: getPrimaryParameter(state).name,
  primaryParameterLevel: getPrimaryParameterLevel(state)
});

export default connect(mapStateToProps)(CategoricalComponent);
